import {postResultToServer} from '../../services/backendClient'

export const NEXT_VIDEO = 'NEXT_VIDEO';

export function nextVideo() {
    return {
        type: NEXT_VIDEO
    };
}

export const UPDATE_AGE_RANGE = 'UPDATE_AGE_RANGE'

export function updateAgeRange(ageRange) {
    return {
        type: UPDATE_AGE_RANGE,
        payload: ageRange
    }
}

export const UPDATE_HEARABILITY = 'UPDATE_HEARABILITY'

export function updateHearability(hearbility) {
    return {
        type: UPDATE_HEARABILITY,
        payload: hearbility
    }
}


export const LOG_RESULT = 'LOG_RESULT';

export function logResult(qualityLevel) {
    return {
        type: LOG_RESULT,
        payload: qualityLevel
    };
}

export const UPDATE_COMMENT = 'UPDATE_COMMENT';

export function updateComment(comment) {
    return {
        type: UPDATE_COMMENT,
        payload: comment
    };
}

let cleanResultData = function (video) {
    return video.remove('video').remove('progress').set('time', new Date());
};

export function sendResultToServer() {
    return async (dispatch, getState) => {
        try {
            const state = getState().get('videotest');
            await postResultToServer(cleanResultData(state));
            dispatch(sendResultsSucceeded());
        } catch (error) {
            dispatch(sendResultsFailed(error.message));
        }
    };
}

export const SEND_RESULTS_SUCCEEDED = 'SEND_RESULTS_SUCCEEDED';

export function sendResultsSucceeded() {
    return {
        type: SEND_RESULTS_SUCCEEDED
    };
}

export const SEND_RESULTS_FAILED = 'SEND_RESULTS_FAILED';

export function sendResultsFailed(message) {
    return {
        type: SEND_RESULTS_FAILED,
        payload: message
    };
}

export const DEVICE_INFO_UPDATED = 'DEVICE_INFO_UPDATED';

export function deviceInfo(info) {
    return {
        type: DEVICE_INFO_UPDATED,
        payload: info
    };
}


// WEBPACK FOOTER //
// ./src/redux/actions/videotest.js